<template>
    <div class="ba-w-100 ba-grid ba-gp-08">
        <div v-if="isBrowserNotif" class="ba-w-100 ba-flex ba-ai-center ba-jc-fe ba-gp-08">
            <button slot="button" class="ba-btn ba-md ba-red ba-h-100" @click.prevent="browserRemove()">{{
                $t('ct-browser-remove') }}</button>
            <button slot="button" class="ba-btn ba-md ba-blue" @click.prevent="openBrowser()">
                <builderall-icon code='4970'></builderall-icon>
                {{ $t('ct-browser-open') }}
            </button>
        </div>
        <div class="ba-w-100 ba-grid ba-gp-08">
            <p>{{ $t('ct-browser-enable-desc') }}</p>
            <div class="ba-grid">
                <div class="ba-w-100 ba-flex ba-ai-center ba-gp-08">
                    <span class='ba-switch ba-sm' @click="browser_notification.open_site_load = !browser_notification.open_site_load">
                        <input type='checkbox' class='ba-checkbox' id="bn-enable-site" v-model="browser_notification.open_site_load">
                        <span class='ba-slider'></span>
                    </span>
                    <small for="bn-enable-site">{{ $t('ct-browser-enable-open-site') }}</small>
                </div>
                <small>{{ $t('ct-browser-enable-open-site-desc') }}</small>
            </div>
        </div>
        <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe ba-gp-08">
            <!-- <button slot="button" class="btn btn-outline-light mt-2" @click.prevent="$refs['browser-bn-enable'].close()">{{ $t('ct-cancel') }}</button> -->
            <button v-if="!isBrowserNotif" class="ba-btn ba-md ba-blue" @click.prevent="browser()">
                <span>{{ $t('ct-browser') }}</span>
            </button>
            <button v-else slot="button" class="ba-btn ba-md ba-blue" @click.prevent="saveBrowserSettingsConfig(null, true)">
                {{ $t('ct-save') }}
            </button>
        </div>
        <modal-delete-component :show="modalDelete.browser.show" :title="modalDelete.browser.text"
            :text="modalDelete.browser.description" :values="modalDelete.browser.config"
            @cancel="cancelModalBrowser('browser')" @exclude="removeBrowserSettings"></modal-delete-component>
    </div>
</template>

<script>
//  import of methods getter and setter of website-config
import { getWebsiteConfig, setWebsiteConfig } from '../../../../js/services/editor/configManager';
import { createBrowserNotif as browserNotif } from '../../../../js/services/integrations-internas/browserNotification';
import ModalDeleteComponent from './../../components/ModalDelete';
import { updateVersion } from '../../../../js/services/editor/publish';
import { mapGetters } from 'vuex';

export default {
    name: 'BrowserNotifications',
    components: {
        ModalDeleteComponent
    },
    data() {
        return {
            websiteObj: {},
            browser_notification: {
                user_email: '',
                user_password: '',
                site_id: '',
                site_name: '',
                project_id: '',
                embed_code: '',
                sw_file: '',
                enabled: false,
                open_site_load: true
            },
            bn_settings: null,
            isBrowserNotif: false,
            modalDelete: {
                browser: {
                    text: this.$t('ct-confirm-delete-browser'), // 'Do you really want to delete this campaign?',
                    // description: 'Deletara as variaveis do browser notification no arquivo website-config',
                    show: false,
                    config: ''
                },

                restrict: { show: false, config: '' }
            }
        };
    },

    watch: {
        'isBrowserNotif': function () {
            this.getBrowserSettings();
        },
    },

    methods: {
        goToWebsite(config) {
            if (config.status !== 'active')
                return;

            window.open('https://' + config.access_url, '_blank');
        },
        /* Browser Notification */
        //  create campaign on browser notification API
        browser() {
            if (this.bn_settings !== null) {
                this.saveBrowserSettings(null, true);
            } else {
                browserNotif({
                    website: {
                        id: this.website.encrypted_id,
                        title: this.website.title
                    }
                }).then(data => {
                    try {
                        if (data['data']['result']) {
                            this.saveBrowserSettings(data, true);
                        } else { //  project browser created yet but desabled
                            if (
                                typeof this.bn_settings['enabled'] !== 'undefined' &&
                                !this.bn_settings['enabled']
                            ) {
                                this.saveBrowserSettings(null, true);
                            } else {
                                this.$snotify.error(this.$t('ct-browser-error'), {
                                    position: 'centerTop'
                                });
                            }
                        }
                    } catch (e) {
                        console.log('erro no retorno da API');
                    }
                })
                    .catch((error) => console.log('error browser link', error))
                    .finally(() => console.log(''));
            }
        },
        browserRemove() {
            if (this.isBrowserNotif) //  true - If project already exists, change enabled to false on: website-config.browserSettings
            { this.confirmDelete('browser', {}) }
        },
        /* Browser Notification */
        //  create campaign on browser notification API
        openBrowser() {
            var site_id = this.website.id;
            if (
                this.bn_settings !== null &&
                typeof this.bn_settings['project_id'] !== 'undefined' &&
                this.bn_settings !== 0 &&
                (typeof this.bn_settings['enabled'] === 'undefined' || this.bn_settings['enabled'])
            ) {
                var project_id = this.bn_settings['project_id'];

                var language = (navigator.language || navigator.userLanguage);
                var bn_url = process.env.BROWSER_NOTIFICATIONS_URL || 'https://notify.builderall.com';
                bn_url += '/login.php';

                var data = {
                    push_pid: project_id,
                    lang: language.substr(0, 2),
                    token: this.getOfficeToken
                };

                if (this.browser_notification.user_email) {
                    data = {
                        ...data,
                        user_email: 'cheetah_ba_' + site_id + '@cheetah_ba.com',
                    };
                }

                var method = 'GET';
                this.postAndRedirect(bn_url, data, method);
            } else {
                this.$snotify.error(this.$t('ct-browser-not-exist'), {
                    position: 'centerTop'
                });
            }
        },
        cancelModal(type) {
            if (this.$refs[type]) {
                this.$refs[type].close();
                return;
            }
            this.modal[type].show = false;
            this.modal[type].config = '';
        },
        // get browser website-configurations
        getBrowserSettings() {
            getWebsiteConfig(this.$route.params.id).then(data => {
                if (typeof data.data.browserSettings !== 'undefined') {
                    this.bn_settings = JSON.parse(data.data.browserSettings.value);
                    if (
                        this.bn_settings !== null &&
                        typeof this.bn_settings['project_id'] !== 'undefined' &&
                        this.bn_settings !== 0 &&
                        (typeof this.bn_settings['enabled'] === 'undefined' || this.bn_settings['enabled'])
                    ) {
                        if (typeof this.bn_settings['userEmail'] !== 'undefined') {
                            this.browser_notification.user_email = this.bn_settings['userEmail'];
                            this.browser_notification.user_password = this.bn_settings['userPassword'];
                            this.browser_notification.site_id = this.bn_settings['siteId'];
                            this.browser_notification.site_name = this.bn_settings['siteName'];
                        }

                        this.browser_notification.project_id = this.bn_settings['project_id'];
                        this.browser_notification.embed_code = this.bn_settings['embed_code'];
                        this.browser_notification.sw_file = this.bn_settings['sw_file'];
                        this.browser_notification.enabled = this.bn_settings['enabled'];
                        this.isBrowserNotif = this.browser_notification.enabled;

                        if (typeof this.bn_settings['open_site_load'] !== 'undefined') {
                            this.browser_notification.open_site_load = this.bn_settings['open_site_load'];
                        }
                    }
                } else {
                }
            });
        },

        // save browser website-configurations
        saveBrowserSettings(result, enabled) {
            let obj = null;
            if (result !== null) { //  create project with success
                obj = {
                    website_id: this.$route.params.id,
                    key: 'browserSettings',
                    value: JSON.stringify({
                        'project_id': result['data']['project_id'],
                        'embed_code': result['data']['embed_code'],
                        'sw_file': result['data']['sw_file'],
                        'enabled': enabled
                    })
                };
                // if (enabled) {
                //     this.$refs['browser-bn-enable'].open();
                // }
            } else { //  re-enable project wich already exists or disable project when confirm delete
                obj = {
                    website_id: this.$route.params.id,
                    key: 'browserSettings',
                    value: JSON.stringify({
                        ...this.bn_settings,
                        ...{
                            'enabled': enabled,
                            'open_site_load': this.browser_notification.open_site_load
                        }
                    })
                };

                // if (enabled) {
                //     this.getBrowserSettings();
                //     this.$refs['browser-bn-enable'].open();
                // }
            }

            setWebsiteConfig(obj).then((data) => {
                this.isBrowserNotif = enabled;
                this.getBrowserSettings();
                this.republishAction();
            })
                .catch((error) => console.log('error save website-config', error));
        },
        saveBrowserSettingsConfig() {
            let obj = {
                website_id: this.$route.params.id,
                key: 'browserSettings',
                value: JSON.stringify({
                    'project_id': this.bn_settings['project_id'],
                    'embed_code': this.bn_settings['embed_code'],
                    'sw_file': this.bn_settings['sw_file'],
                    'enabled': true,
                    'open_site_load': this.browser_notification.open_site_load
                })
            };
            setWebsiteConfig(obj)
                .then((data) => {
                    this.isBrowserNotif = true;
                    this.getBrowserSettings();
                    this.republishAction(false);
                    // this.$refs['browser-bn-enable'].close();

                    this.$snotify.success(this.$t('ct-success-true'), {
                        position: 'centerTop'
                    });
                })
                .catch((error) => console.log('error save website-config', error));
        },
        republishAction(showAlert = true) {
            updateVersion(this.website.encrypted_id)
                .then(res => {
                    console.log(res.data);
                });

            if (showAlert) {
                this.$snotify.success(this.$t('ct-republished'), {
                    position: 'centerTop'
                });
            }
        },
        removeBrowserSettings() {
            this.cancelModalBrowser('browser');
            this.saveBrowserSettings(null, false);
            this.isBrowserNotif = !this.isBrowserNotif;
            this.getBrowserSettings();
        },
        cancelModalBrowser(type) {
            this.modalDelete[type].show = false;
            this.modalDelete[type].config = '';
        },
        confirmDelete(type, config) {
            this.modalDelete[type].text = this.$t(`ct-confirm-delete-${type}`);
            this.modalDelete[type].show = true;
            this.modalDelete[type].config = config;
        },
        postAndRedirect(url, postData, method) {
            if (method === undefined) {
                method = 'POST';
            }
            var blank = '_blank';
            var postFormStr = "<form method='" + method + "' action='" + url + "' target='" + blank + "'>\n";
            for (var key in postData) {
                if (postData.hasOwnProperty(key)) {
                    if (postData[key] !== undefined && postData[key] !== null) {
                        if (postData[key] instanceof Array) { // => If is array, loop through
                            postData[key].forEach(function (entry) {
                                postFormStr += "<input type='hidden' name='" + key + "[]' value='" + entry + "' />";
                            });
                        } else {
                            postFormStr += "<input type='hidden' name='" + key + "' value='" + postData[key] + "' />";
                        }
                    }
                }
            }
            postFormStr += '</form>';
            var formElement = $(postFormStr);
            $('body').append(formElement);
            $(formElement).submit();
        },
    },
    mounted() {
        this.getBrowserSettings();
        vm.$forceUpdate();
    },
    computed: {
        ...mapGetters({getUser: 'user', getUserToken: 'token', getOfficeToken: 'getOfficeToken', website: 'website'}),
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/dashboard/layout/site/BrowserNotifications.vue